import { Component } from '@angular/core';
import { AiAssistantComponent } from '../../components/ai-assistant/ai-assistant.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-ai-chat-page',
  standalone: true,
  imports: [AiAssistantComponent],
  template: `
    <main class="bw-ai-chat-page">
      <app-ai-assistant [user]="authService.currentUser" presentation="page"></app-ai-assistant>
    </main>
  `,
  styles: [`
    :host { display: flex; flex: 1 1 auto; min-width: 0; min-height: 0; overflow: hidden; }
    .bw-ai-chat-page { box-sizing: border-box; display: flex; flex: 1 1 auto; align-self: stretch; min-width: 0; min-height: 0; width: 100%; max-width: 60rem; height: 100%; margin: 0 auto; padding: 1rem; overflow: hidden; }
    .bw-ai-chat-page > app-ai-assistant { display: block; flex: 1 1 auto; min-width: 0; min-height: 0; width: 100%; }
    @media (max-width: 640px) { .bw-ai-chat-page { padding: 0; } }
  `]
})
export class AiChatPageComponent {
  constructor(readonly authService: AuthService) {}
}
